import api from './api';
import { CustomerLoginRequest, CustomerLoginResponse, CustomerRegisterRequest } from '../models';

export interface ResetPasswordRequest {
  email: string;
  token: string;
  newPassword: string;
}

export const authService = {
  login: (data: CustomerLoginRequest) =>
    api.post<CustomerLoginResponse>('/store/auth/login', data).then((r) => r.data),

  register: (data: CustomerRegisterRequest) =>
    api.post<CustomerLoginResponse>('/store/auth/register', data).then((r) => r.data),

  forgotPassword: (email: string) =>
    api.post('/auth/forgot-password', { email, origin: 'store' }).then((r) => r.data),

  resetPassword: (data: ResetPasswordRequest) =>
    api.post('/auth/reset-password', data).then((r) => r.data),
};
